import { render } from "./Scan_Notes.vue?vue&type=template&id=07df6f02"
import script from "./Scan_Notes.vue?vue&type=script&lang=js"
export * from "./Scan_Notes.vue?vue&type=script&lang=js"

import exportComponent from "/home/emcy/Dev/FaunaLife/fauna.life_puppy_vue_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QCarousel,QCarouselSlide,QBadge});
